import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import Button from '../../components/ui/Button';
import PhotoFiles from '../../components/ui/PhotoFiles';
import { apiPhotoAlbumCreate } from '../../actions/photoActions';
import { renderField } from '../../fields';
import { videoFields } from '../../fields/video';
import PageNotFound from '../pagenotfound/PageNotFound';

function PhotoUpload() {
  const token = useSelector((state: any) => state.user.token);
  const user = useSelector((state: any) => state.user.user);
  const navigate = useNavigate();

  const [files, setFiles] = useState<any[]>([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState<any>(null);
  const [filmingDate, setFilmingDate] = useState<Date>(moment().toDate());
  const [titleError, setTitleError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [locationError, setLocationError] = useState('');
  const [filmingDateError, setFilmingDateError] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [fileError, setFileError] = useState(false);

  const submit = async () => {
    let hasError = false;

    if (!title.trim()) {
      setTitleError('Title is required');
      hasError = true;
    }
    if (!description.trim()) {
      setDescriptionError('Description is required');
      hasError = true;
    }
    if (!location) {
      setLocationError('Location is required');
      hasError = true;
    }
    if (!filmingDate) {
      setFilmingDateError('Filming date is required');
      hasError = true;
    }

    if (hasError) {
      return;
    }

    if (files.filter((file: any) => file.completed).length === 0) {
      setFileError(true);
      return;
    }

    setSubmitLoading(true);

    try {
      const apiResponse = await apiPhotoAlbumCreate({
        token,
        title,
        description,
        location,
        filmingDate: moment(filmingDate).format('YYYY-MM-DD'),
        user_id: user.id,
        photos: files.filter((file: any) => file.completed).map((file: any) => file.id),
      });
      if (apiResponse.status) {
        if (user?.role === 'stringer') {
          navigate(`/profile?tab=photos`);
        }
        if (user?.role === 'admin') {
          navigate(`/panel/photos`);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  if (['admin', 'stringer'].indexOf(user?.role) === -1) {
    return <PageNotFound />;
  }

  return (
    <>
      <div className="video-page-top">
        <div
          onClick={() => {
            navigate(-1);
          }}
          className="video-page-top-back-icon"
        >
          <i className="fa fa-angle-left" />
        </div>
        <span className="video-page-top-title">Upload photos</span>
        <div className="video-page-top-right"></div>
      </div>
      <div className="create-page-row row" style={{ marginTop: '20px' }}>
        <div className="create-page-block photo-upload-block-left">
          <div className="create-page-block-inner">
            {renderField({
              ...videoFields.title,
              value: title,
              error: titleError,
              onChange: (value: string) => {
                setTitle(value);
                setTitleError('');
              },
              className: 'create-page-block-element',
              required: true,
            })}
            <div className="create-page-block-row row">
              <div className="create-page-block-row-col large">
                {renderField({
                  ...videoFields.location,
                  value: location,
                  error: locationError,
                  onChange: (value: any) => {
                    setLocation(value);
                    setLocationError('');
                  },
                  className: 'create-page-block-element',
                  required: true,
                })}
              </div>
              <div className="create-page-block-row-col small">
                {renderField({
                  ...videoFields.filmingDate,
                  value: filmingDate,
                  error: filmingDateError,
                  onChange: (value: Date) => {
                    setFilmingDate(value);
                    setFilmingDateError('');
                  },
                  className: 'create-page-block-element',
                  required: true,
                })}
              </div>
            </div>
            {renderField({
              ...videoFields.description,
              value: description,
              error: descriptionError,
              onChange: (value: string) => {
                setDescription(value);
                setDescriptionError('');
              },
              className: 'create-page-block-element',
              required: true,
            })}
            <div style={{ height: '20px', width: '1px' }} />
          </div>
        </div>
        <div className="create-page-block photo-upload-block-right">
          <PhotoFiles
            onChangeFiles={(files: any) => {
              setFiles(files);
              setFileError(fileError && files.filter((file: any) => file.completed).length === 0);
            }}
          />
          {fileError && <span className="video-upload-error">Upload photo files</span>}
        </div>
      </div>
      <div className="bottom-area">
        <div className="bottom-area-inner">
          <div className="bottom-area-right">
            <Button
              className={'blue bottom-area-submit-button'}
              label={'Submit'}
              loading={submitLoading}
              onClick={submit}
              type={'button'}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PhotoUpload;
